import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ModusButtonModule, ModusIconModule, ModusTooltipModule } from '@trimble-gcs/modus';

export interface UsageValue {
  label: string;
  value: string;
  percentage: number;
}

@UntilDestroy()
@Component({
  selector: 'sd-usage-bar',
  imports: [ModusButtonModule, ModusIconModule, ModusTooltipModule],
  templateUrl: './usage-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsageBarComponent {
  @Input() usageValueBackground!: UsageValue;
  @Input() usageValueForeground!: UsageValue;
}
